<template>
<!-- 题目管理(校验题目) 弹窗：批量导入题目 -->
    <div>
        <el-dialog :title="setNumberTextConfig.title" :visible.sync="difficultyDialogVisible" width="420px" @close="difficultyDialogClose" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-form :model="difficultyForm" ref="difficultyForm">
                <el-form-item>
                    <el-radio-group v-model="difficultyForm.difficulty" style="margin-left:60px">
                        <el-radio v-for="item in $parent.difficultyOptions" :key="item.dict_value" :label="item.dict_value" style="margin-right:52px">{{item.dict_label}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="difficultyDialogClose">{{ setNumberTextConfig.ok }}</el-button>
                <el-button type="primary" @click="difficultySubmit">{{ setNumberTextConfig.cancel }}</el-button>
            </span>
        </el-dialog>
<!-- 题目管理(校验题目) 弹窗：批量设置分值 -->
        <el-dialog :title="setScoreTextConfig.title" :visible.sync="scoreDialogVisible" width="420px" @close="scoreDialogClose" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-form :model="scoreForm" :rules="scoreRules" ref="scoreForm" label-width="80px">
                <el-form-item :label="setScoreTextConfig.score" prop="score">
                    <el-input-number v-model="scoreForm.score" :min="0" :step="0.1" step-strictly></el-input-number>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="scoreDialogClose">{{ setScoreTextConfig.cancel }}</el-button>
                <el-button type="primary" @click="submitForm()">{{ setScoreTextConfig.ok }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: ['setDifficultyShow','setScoreShow','row'],
    data() {
        let $this = this
        return {
            difficultyDialogVisible: false,
            scoreDialogVisible: false,
            difficultyForm: {
                difficulty: 'normal'
            },
            scoreForm: {
                score: 2
            },
            scoreRules: {
                score: [
                    { required: true, message: this.$store.state.global.textConfig.backend.question.table.button.setScore.scoreNullMessage, trigger: 'change' },
                    {
                        validator: function(rule, value, callback) {
                            if (value===0) {
                                callback(new Error($this.$store.state.global.textConfig.backend.question.table.button.setScore.scoreZeroMessage));
                            } else {
                                callback();
                            }
                        },
                        trigger: "change"
                    }
                ],
            }
        }
    },
    computed: {
        setNumberTextConfig() {
            return this.$store.state.global.textConfig.backend.question.table.button.setNumber
        },
        setScoreTextConfig() {
            return this.$store.state.global.textConfig.backend.question.table.button.setScore
        }
    },
    watch: {
        setDifficultyShow() {
            this.difficultyDialogVisible = this.setDifficultyShow;
        },
        setScoreShow() {
            this.scoreDialogVisible = this.setScoreShow;
        }
    },
    methods: {
        difficultySubmit() {
            if (!this.row[0]) {
                this.$message({
                    message: this.setNumberTextConfig.success,
                    type: 'success'
                });
                this.$emit('difficultyDialogClose', this.difficultyForm.difficulty)
                this.difficultyDialogClose()
            }else {
                let row = []
                for (let j = 0; j < this.row.length; j++) {
                    const e = this.row[j].id;
                    row.push(e)
                }
                this.$store.dispatch("batchSetDifficulty", {question_id:row.join(','),difficulty:this.difficultyForm.difficulty}).then(res => {
                    if (res.status == 200) {
                        this.$message({
                            message: this.setNumberTextConfig.success,
                            type: 'success'
                        });
                        this.$parent.search(1)
                    }
                    this.difficultyDialogClose()
                })
            }
        },
        submitForm() {
            if (this.scoreForm.score) {
                if (!this.row[0]) {
                        this.$message({
                            message: this.setScoreTextConfig.success,
                            type: 'success'
                        });
                        this.$emit('scoreDialogClose', this.scoreForm.score)
                        this.scoreDialogClose()
                }else {
                    let row = []
                    for (let j = 0; j < this.row.length; j++) {
                        const e = this.row[j].id;
                        row.push(e)
                    }
                    setTimeout(() => {
                        this.$store.dispatch("batchSetScore", {question_id:row.join(','),score:this.scoreForm.score}).then(res => {
                            if (res.status == 200) {
                                this.$message({
                                    message: this.setScoreTextConfig.success,
                                    type: 'success'
                                });
                                this.$parent.search(1)
                            }
                            this.scoreDialogClose()
                        })
                    }, 400);
                }
            }
        },
        difficultyDialogClose() {
            this.difficultyDialogVisible = false
            this.$emit('update:setDifficultyShow', false);
            this.difficultyForm.difficulty = 'normal'
        },
        scoreDialogClose() {
            this.scoreDialogVisible = false
            this.$emit('update:setScoreShow', false);
            this.scoreForm.score = 2
        }
    }
}
</script>

<style>
</style>
